<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPresentationOn_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3 2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm10 9a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10Zm0-7H3v6h10V4Zm-2.667 9H5.667l-.447 1.342a.499.499 0 0 0 .474.658h4.613a.5.5 0 0 0 .474-.658L10.333 13Z"
        clip-rule="evenodd"
    />
</svg>
